import { useMemo } from "react";

import { parseMarkdownDocument } from "@/lib/content/markdown";

export function useMarkdownDocument(source?: string | null) {
  return useMemo(() => parseMarkdownDocument(source ?? ""), [source]);
}
